<template>
    <div class="toast">{{ text }}</div>
</template>

<script>
export default {
    props: {
        text: {
            type: String,
            default: ''
        }
    },
    mounted() {
        document.body.appendChild(this.$el);
    },
    destroyed() {
        if (this.$el && this.$el.parentNode) {
            this.$el.parentNode.removeChild(this.$el);
        }
    }
};
</script>

<style lang="scss">
@import '../theme/mixin.scss';
.toast {
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    padding: 20px 40px;
    background: rgba(0, 0, 0, 0.8);
    border-radius: 5px;
    z-index: var(--level-high);
    font-size: 18px;
    color: #fff;
    text-align: center;
    width: 70%;
    max-width: 500px;
    @include webkitBox(5);
}
</style>
